import React from "react";
import { Helmet } from "react-helmet-async";
import images from "../../images";
import { useTranslation } from "react-i18next";

const Header = ({
  title = "Quests",
  backIcon,
  onBackClick,
  menuIcon,
  onMenuClick,
  btnEdit,
  handleEdit,
  classNameBtnEdit,
  showAchievement,
  xp,
  trophyIcon,
  isDropDownOpen,
  onDropDownPauseClick,
  onDropDownEndClick,
  subTitle,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col relative w-full max-w-[368px] bg-[#4f46e5] rounded-none rounded-bl-xl rounded-br-xl pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] min-h-[calc(60px+env(safe-area-inset-top))]">
      <Helmet>
        <meta name="theme-color" content="#4f46e5" />
      </Helmet>
      <div className="flex flex-1 gap-10 justify-between items-center px-4 py-2.5 size-full">
        {backIcon ? (
          <div
            onClick={() => typeof onBackClick === "function" && onBackClick()}
          >
            <img
              loading="lazy"
              src={backIcon}
              alt="Logo"
              className="object-contain shrink-0 self-stretch my-auto aspect-square w-[42px]"
            />
          </div>
        ) : (
          <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]" />
        )}

        <div className="gap-1 self-stretch my-auto text-lg font-semibold leading-relaxed text-white whitespace-nowrap">
          {title}
        </div>

        {menuIcon ? (
          <div
            onClick={() => typeof onMenuClick === "function" && onMenuClick()}
            className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]"
          >
            <img
              loading="lazy"
              src={menuIcon}
              alt="Avatar"
              className="object-contain self-stretch my-auto w-9 rounded-md aspect-square"
            />
            {isDropDownOpen && (
              <div className="flex flex-col absolute right-[21px] top-[55px] z-50  gap-2.5 justify-center items-center bg-white rounded-[10px] py-1 w-[130px] shadow-[0_2px_6px_-2px_rgba(0,0,0,0.08)]   border-[#EEEAE8] border-solid border-[1px]">
                <div
                  onClick={() =>
                    typeof onDropDownEndClick === "function" &&
                    onDropDownEndClick()
                  }
                  className="flex flex-row cursor-pointer  items-center gap-2 hover:bg-[#FCF8E6] px-2 py-1.5 rounded-sm w-full"
                >
                  <img
                    src={images.CarbonCloseOutline}
                    alt=""
                    className="w-4 h-4"
                  />

                  <span className="text-sm">
                    {t("quest.detailMultipleChoice.quitQuest")}
                  </span>
                </div>
                <div
                  onClick={() =>
                    typeof onDropDownPauseClick === "function" &&
                    onDropDownPauseClick()
                  }
                  className="flex flex-row cursor-pointer  items-center gap-2 hover:bg-[#FCF8E6] px-2 py-1.5 rounded-sm w-full"
                >
                  <img
                    src={images.CarbonPauseOutline}
                    alt=""
                    className="w-4 h-4"
                  />

                  <span className="text-sm">
                    {t("quest.detailMultipleChoice.pauseQuest")}
                  </span>
                </div>
              </div>
            )}
          </div>
        ) : btnEdit ? (
          <button className={classNameBtnEdit} onClick={handleEdit}>
            {btnEdit}
          </button>
        ) : subTitle ? (
          <div
            onClick={() =>
              typeof onDropDownEndClick === "function" && onDropDownEndClick()
            }
            className="flex bg-white cursor-pointer px-1 overflow-hidden gap-[6px] justify-center items-center self-stretch  my-auto rounded-[5px] h-[32px] w-[80px]"
          >
            <span className="text-xs text-[#EF4056]">{subTitle}</span>
          </div>
        ) : (
          <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]" />
        )}
      </div>

      {showAchievement && (
        <div className="w-full max-w-[460px] grid grid-cols-2 gap-4 px-4 pb-4 mx-auto">
          <div className="bg-amber-50 rounded-xl p-3 flex flex-col items-center">
            <span className="text-gray-800 text-sm">
              {t("header.unlockAchievements")}
            </span>
            <img src={trophyIcon} alt="Trophy" className="w-8 h-8" />
          </div>
          <div className="bg-amber-50 rounded-xl p-3 flex flex-col items-center">
            <span className="text-gray-800 text-sm mb-1">
              {t("header.receive")}
            </span>
            <div className="flex items-center gap-1">
              <span className="text-blue-600 font-semibold text-2xl">
                {xp || 15}
              </span>
              <span className="text-blue-600 font-semibold text-2xl">XP</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
